jQuery( document ).ready( function() {
	let indulgence = [];
	let tours = [];
	let dining = [];
	let region = [];
	let paged;
	let minVal;
	let maxVal;
	let keyword;
	let order;
	let typingTimer;
	const typingDelay = 3000;

	// Function to check if any filter is active
	function toggleClearButton() {
		if (
			indulgence.length ||
			tours.length ||
			dining.length ||
			region.length ||
			( keyword && keyword.trim() !== '' ) ||
			( minVal != null && minVal !== '' ) ||
			( maxVal != null && maxVal !== '' )
		) {
			jQuery( '.clear-filter-button' ).show();
		} else {
			jQuery( '.clear-filter-button' ).hide();
		}
	}

	// Clear filter click - reload the page
	jQuery( document ).on( 'click', '.clear-filter-button', function() {
		location.reload(); // Reload to reset everything
	} );

	function initMapElevate( staysData ) {
	// Check if staysData exists and is an array

		// Use the first stay as the center
		if ( staysData[ 0 ] && staysData[ 0 ].lat && staysData[ 0 ].lng ) {
			center = {
				lat: parseFloat( staysData[ 0 ].lat ),
				lng: parseFloat( staysData[ 0 ].lng ),
			};
		} else {
			center = {
				lat: -25.2744,
				lng: 133.7751,
			};
		}

		// Create the map
		const map = new google.maps.Map( document.getElementById( 'single-elevate-map' ), {
			zoom: 6,
			center,
		} );

		// Loop through the stays and add markers
		if ( staysData ) {
			staysData.forEach( ( stay ) => {
				if ( stay.lat && stay.lng ) {
					new google.maps.Marker( {
						position: {
							lat: parseFloat( stay.lat ),
							lng: parseFloat( stay.lng ),
						},
						map,
						title: `Post ID: ${ stay.post_id }`,
					} );
				}
			} );
		} else {
			new google.maps.Marker( {
				map,
			} );
		}
	}

	jQuery( '#ajax-perks-search' ).on( 'input', function() {
		clearTimeout( typingTimer ); // clear previous timer

		keyword = jQuery( this ).val();
		toggleClearButton();

		typingTimer = setTimeout( function() {
			console.log( 'Sending AJAX with keyword:', keyword );
			SendAjaxElevates(); // send request after delay
			// let targetY;
			// if ( jQuery( 'body' ).hasClass( 'logged-in' ) ) {
			// 	targetY = jQuery( '#elevatespage' ).offset().top - 280;
			// } else {
			// 	targetY = jQuery( '#elevatespage' ).offset().top - 260;
			// }
			// jQuery( 'html, body' ).animate( {
			// 	scrollTop: targetY,
			// }, );
		}, typingDelay );
	} );

	jQuery( '.ajax-perk-item' ).on( 'change', function() {
		indulgence = [];
		tours = [];
		dining = [];
		region = [];
		jQuery( '.perks-filter-item:checked' ).each( function() {
			const key = jQuery( this ).data( 'key' );
			const value = jQuery( this ).attr( 'id' );
			if ( key == 'indulgence' ) {
				indulgence.push( value );
			}
			if ( key == 'tours' ) {
				tours.push( value );
			}
			if ( key == 'dining' ) {
				dining.push( value );
			}
			if ( key == 'region' ) {
				region.push( value );
			}
		} );
		console.log( indulgence );
		console.log( dining );

		toggleClearButton();
		SendAjaxElevates();
		let targetY;
		if ( jQuery( 'body' ).hasClass( 'logged-in' ) ) {
			targetY = jQuery( '#elevatespage' ).offset().top - 280;
		} else {
			targetY = jQuery( '#elevatespage' ).offset().top - 260;
		}
		jQuery( 'html, body' ).animate( {
			scrollTop: targetY,
		}, );
		console.log( dining );
	} );
	function ElevatesPagination() {
		jQuery( '.perks-pagination' ).on( 'click', 'button[data-page]', function( e ) {
			e.preventDefault();

			paged = jQuery( this ).data( 'page' );

			if ( paged ) {
			  console.log( 'Requested page:', paged );
			  SendAjaxElevates();
			 	let targetY;
				if ( jQuery( 'body' ).hasClass( 'logged-in' ) ) {
					targetY = jQuery( '#elevatespage' ).offset().top - 280;
				} else {
					targetY = jQuery( '#elevatespage' ).offset().top - 260;
				}
				jQuery( 'html, body' ).animate( {
					scrollTop: targetY,
				}, );
			  // Call your AJAX function here
			  // Example: loadStays(page);
			}
		  } );
	}
	ElevatesPagination();

	jQuery( '.ajax-perk-order' ).on( 'click', function() {
		order = jQuery( this ).data( 'value' );
		console.log( order );
		toggleClearButton();
		SendAjaxElevates();
	} );

	const $rangeInputs = jQuery( '.ajax-range-elevates-slider input[type="range"]' );
	const $minValueDisplay = jQuery( '.minimum .value' );
	const $maxValueDisplay = jQuery( '.maximum .value' );

	function elevateValues() {
		 minVal = parseInt( $rangeInputs.eq( 0 ).val() );
		 maxVal = parseInt( $rangeInputs.eq( 1 ).val() );

		console.log( minVal );
		console.log( maxVal );

		if ( minVal > maxVal ) {
			[ minVal, maxVal ] = [ maxVal, minVal ];
		}

		$minValueDisplay.text( `$${ minVal }` );
		$maxValueDisplay.text( `$${ maxVal }` );
	}

	// Run on input change
	$rangeInputs.on( 'change', function() {
		elevateValues();
		toggleClearButton();
		SendAjaxElevates();
	} );

	function SendAjaxElevates() {
		jQuery( '.loader-container' ).show();

		jQuery.ajax( {
			url: localVars.ajax_url,
			type: 'POST',
			data: {
				action: 'perks_filter',
				indulgence,
				tours,
				dining,
				minVal,
				maxVal,
				keyword,
				region,
				paged,
				order,

			},
			success( response ) {
				jQuery( '.loader-container' ).hide();
				console.log( 'AJAX Success:', response.args );
				jQuery( '#perks-container' ).html( response.html );
				jQuery( '#ajax-elevates-pagination' ).html( response.pagination );
				// console.log( response.pagination );
				ElevatesPagination();
				initMapElevate( response.map_data );
				toggleClearButton();
			},
			error( xhr, status, error ) {
				jQuery( '.loader-container' ).hide();
				console.error( 'AJAX Error:', error );
				console.log( 'Full Response:', xhr.responseText );
				alert( 'Something went wrong. Please try again.' );
			},
		} );
	}
} );
